export default "__VITE_ASSET__Cdek154E__"